<template>
  <div>
    <p class="title">{{$t('message.index.partners')}}</p>
    <div class="list">
      <div class="li" v-for="item in list" :key="index">
        <img :src="item.image" alt="" @click="openUrl(item.url)" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "friends",
  props: {
    list: Array
  },
  components: {},
  data: function() {
    return {
      openUrl(url) {
        window.location.href = url;
      }
    };
  },
  methods: {}
};
</script>
<style scoped>
.list {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0.3rem 0.6rem 0.3rem;
  background: #fff;
  box-sizing: border-box;
  flex-wrap: wrap;
}
.title {
  width: 100%;
  line-height: 0.6rem;
  color: #333;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #fff;
  font-size: 0.3rem;
}
.list .li {
  width: 49%;
  height: 1.2rem;
  margin-bottom: 0.15rem;
}
.list .li img {
  width: 100%;
  height: 100%;
}
</style>
